// src/components/AuthGuard.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken } from '../api/client';

export default function AuthGuard({ children }) {
  const token = getAuthToken();
  return token ? children : <Navigate to="/login" replace />;
}
